common.View.create('galaxy::habitats.website.layouts.Main', {

    onDOMLoad() {
        this.initHeader();
        this.initMailCart();
        this.initScrollTop();
    },

    initHeader()
    {
        this.element.find('.header-slider .slider')
            .owlCarousel({
                autoplayTimeout: 8000,
                autoplaySpeed: 1000,
                pagination: false,
                autoplay: true,
                loop: true,
                nav: true,
                dots: false,
                items: 1
            });
    },

    initMailCart()
    {
        let i = 0;

        $(document).mouseleave((event) => {
            if( ++i > 1)
                return;

            if( this.element.find('.mailCart').length &&
                (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight))
            ) {
                // Disable scrolling
                $('body').css('overflow', 'hidden');

                // Open mail cart
                this.element.find('.mailCart')
                    .fadeIn('fast')

                    // Handle trigger
                    .on('click', (event) => {
                        // Check if user is clicking outside of div or on quit button
                        if (($(event.target).is('a.quit') || $(event.target).parents('a.quit').length) ||
                            ( !$(event.target).is('.item') && !$(event.target).parents('.mailCart').length )
                        ) {
                            // Fade out again
                            $(event.currentTarget).fadeOut('fast');

                            // Enable scrolling
                            $('body').css('overflow', 'auto');
                        }
                    });
            }
        });
    },

    initScrollTop()
    {
        this.element.find('.scrollTop')
            .hide()
            .on('click', (event) => {
                $('html,body').animate({ scrollTop: 0 }, 'slow');

                return false;
            });

        // On scroll; show button
        $(window).scroll((event) => {
            // Check if user has scrolled from top
            if ( $(event.currentTarget).scrollTop() >= 50 ) {
                this.element
                    .find('.scrollTop')
                        .stop(true, true)
                        .fadeIn();
            } else {
                this.element
                    .find('.scrollTop')
                        .stop(true, true)
                        .fadeOut();
            }
        });
    }

});
